var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',_vm._g(_vm._b({attrs:{"value":_vm.value}},'div',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }